export default "__VITE_ASSET__C$bPRmfu__"